import { CollectionContext } from './CollectionProvider';

export const useCollectionContext = () => CollectionContext.hook();
